export enum FormType {
  Application = 'Application',
  Survey = 'Survey',
  Evaluation = 'Evaluation',
  Team = 'Team',
}
